const dashboard = '/';
const login = '/login';
const profile = '/profil';
const personal_data = '/profil/szemelyesadatok';
const settings = '/profil/beallitasok';
const contact = '/kapcsolat';
const notifications = '/profil/ertesitesek';
const login_settings = '/profil/beallitasok/belepesi-adatok';
const logout_settings = '/profil/beallitasok/kilepesi-adatok';
const locale_settings = '/profil/beallitasok/nyelv-modositas';
const password_change = '/profil/beallitasok/jelszo-modositas';
const messages = '/uzenetek';
const exchange_orders = '/megbizasok/tozsdei';
const new_exchange_order = '/megbizasok/tozsdei/uj';
const exchange_order_details = '/megbizasok/tozsdei/:id';
const unit_orders = '/megbizasok/befektetesijegy';
const unit_order_details = '/megbizasok/befektetesijegy/:id';
const money_transitions = '/rendelkezesek/penz-atvezetes';
const money_transition_details = '/rendelkezesek/penz-atvezetes/:id';
const security_transitions = '/rendelkezesek/ertekpapir-atvezetes';
const security_transition_details = '/rendelkezesek/ertekpapir-atvezetes/:id';
const currency_conversions = '/rendelkezesek/devizakonverzio';
const currency_conversion_details = '/rendelkezesek/devizakonverzio/:id';
const security_transfers = '/rendelkezesek/ertekpapir-transzfer';
const security_transfer_details = '/rendelkezesek/ertekpapir-transzfer/:id';
const money_transfers = '/atutalasok';
const money_transfer_details = '/atutalasok/:id';

export const Paths = {
  login,
  dashboard,
  profile,
  personal_data,
  contact,
  settings,
  notifications,
  login_settings,
  logout_settings,
  locale_settings,
  password_change,
  messages,
  exchange_orders,
  new_exchange_order,
  exchange_order_details,
  unit_orders,
  unit_order_details,
  money_transitions,
  money_transition_details,
  security_transitions,
  security_transition_details,
  currency_conversions,
  currency_conversion_details,
  security_transfers,
  security_transfer_details,
  money_transfers,
  money_transfer_details,
};
